<template>
	<div class="header">
		<div class="header-top">
			<!--图标-->
			<!-- <div>
				<img src="../assets/images/logo.png" alt="">
			</div> -->
			<!--登录状态-->
			<div class="name">
        <el-dropdown  @command="handleCommand">
          <span class="el-dropdown-link">
            {{ zhuangtai }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="a">修改密码</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

			<!--推出功能-->
			<span class="out" @click="SignOut" style="cursor: pointer;">退出</span>
		</div>

    <el-dialog
      title="修改密码"
      :visible.sync="dialogVisible"
      width="30%"
      >
<!--      <span>这是一段信息</span>-->
      <div class="itemIpt" style="margin-bottom: 20px">
        <span>旧密码:</span><el-input placeholder="请输入旧密码" v-model.trim="inputOld" show-password></el-input>
      </div>
      <div class="itemIpt">
        <span>新密码:</span><el-input placeholder="请输入新密码" v-model.trim="inputNew" show-password></el-input>
      </div>

      <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="passTrue">确 定</el-button>
  </span>
    </el-dialog>
	</div>
</template>

<script>
	import {
		account_logout
	} from '../assets/js/network/network.js';
	export default {
		name: 'NavHeader',
		data() {
			return {
				userInfo:"",
				imgs: '../assets/images/logo.png',
				zhuangtai: 'admin',
        dialogVisible:false,
        inputOld:'',
        inputNew:'',
			}
		},
		components: {

		},
		methods: {
			SignOut(){
				let data={}
				account_logout(data).then(res=>{
          this.$store.commit('setLogoUrl', '')
					sessionStorage.clear();
					localStorage.clear();
					this.$router.push('/')
				})
			},
      handleCommand(command) {
         this.dialogVisible = true
      },
      passTrue(){
        if(!this.inputOld){
          this.$message.error("请输入旧密码")
          return
        }
			  if(!this.inputNew){
			    this.$message.error("请输入新密码")
          return
        }
        let reg = /^[^\u4e00-\u9fa5]{6,15}$/;  //正则使用方式 reg.test("内容")
        if(!reg.test(this.inputNew)){
          //如果为true,则代表内容中有汉字
          this.$message.error("新密码6-15位并且不能包含汉字")
          return
        }
			  if(localStorage.getItem('pass') != this.$md5(this.inputOld)){
          this.$message.error("旧密码不正确")
          return
        }
        if(this.$md5(this.inputNew) == this.$md5(this.inputOld)){
          this.$message.error("新旧密码不能相同")
          return
        }
        let data = {
          user:this.zhuangtai,
          password:this.$md5(this.inputNew)
        }
        this.$post(this.$api.accountPasswordReset,data).then(res=>{
          if(res.code == 0){
            localStorage.setItem("pass",data.password)
            this.$message.success("修改密码成功,将要重新登录")
            this.SignOut()
            this.dialogVisible =false
          }
        })
			  // console.log(this.inputOld,this.inputNew)
      }
		},
    watch:{
      dialogVisible(){
        if(!this.dialogVisible){
          this.inputOld = ''
          this.inputNew = ''
        }
      },
    },
		mounted() {
           this.userInfo = JSON.parse(localStorage.getItem("session"))
		   console.log(this.userInfo)
		   this.zhuangtai =this.userInfo.account
		}
	}
</script>

<style scoped>
	.header {
		width: 100%;
		height: 56px;
		background-image: linear-gradient(to right, #6abc74, #00b5ca);
	}

	.header-top {
		/* line-height: 32px; */
		display: flex;
		justify-content: flex-end;
	}

	.header-top img {
		width: 32px;
		height: 32px;
		margin-top: 16px;
	}

	.header-top .out {
		margin: 20px 30px;
	}

	.header-top .name{
		margin-top: 20px;
		margin-left: 7px;

	}
  .header-top .name span{
    cursor: pointer;
    font-size: 16px;
  }
  .itemIpt{
    display: flex;
    align-items: center;
  }
  .itemIpt span{
   width: 60px;
  }
</style>

